import { graphql } from 'react-relay';

/**
 * The in-context write actions on a single vault's toggles. Each returns the
 * server's authoritative state so the caller can reconcile optimistic UI. Kept
 * in `relay/` (not a screen) so the `graphql` tag stays confined to
 * Babel-transformed data modules.
 */

/** Move a vault into a rollout ring (Internal / Beta / GA). */
export const setVaultRingMutation = graphql`
    mutation vaultToggleMutationsSetVaultRingMutation($vaultId: UUID!, $ring: VaultRing!) {
        setVaultRing(vaultId: $vaultId, ring: $ring) {
            vaultId
            ring
        }
    }
`;

/** Pin a flag on or off for a single vault, ahead of its rollout. */
export const setFeatureOverrideMutation = graphql`
    mutation vaultToggleMutationsSetFeatureOverrideMutation(
        $key: FeatureKey!
        $vaultId: UUID!
        $state: OverrideState!
    ) {
        setFeatureOverride(key: $key, vaultId: $vaultId, state: $state) {
            flagKey
            vaultId
            state
        }
    }
`;

/** Remove a vault's per-flag override so the flag falls back to its rollout. */
export const clearFeatureOverrideMutation = graphql`
    mutation vaultToggleMutationsClearFeatureOverrideMutation($key: FeatureKey!, $vaultId: UUID!) {
        clearFeatureOverride(key: $key, vaultId: $vaultId)
    }
`;
